import * as React from 'react';
import { createSvgIcon } from '@mui/material';
var PartialCircle = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  id: "circle_partial-a",
  d: "M12,2 C17.52,2 22,6.48 22,12 C22,17.4264407 17.6705774,21.8478368 12.2797649,21.9961558 L12,22 L11.7202351,21.9961558 C6.32942258,21.8478368 2,17.4264407 2,12 C2,6.57355932 6.32942258,2.15216317 11.7202351,2.00384421 L12,2 Z M12,4 L12,20 L12,20 C16.42,20 20,16.42 20,12 C20,7.58 16.42,4 12,4 Z"
}), 'PartialCircle');
export { PartialCircle };